class TreeHelperClass {
    getParentItem = (item, breadArray = []) => {
        const {level, parent, data} = item;
        
        if(level > 0) {
            this.getParentItem(parent, breadArray);
        }
        let breadCrumbItem = {id: data.id, name: data.name}
        breadArray.push(breadCrumbItem);
        
        return breadArray;
    }
        
    getBreadCrumb = (item) => {
        const {level} = item;

        let breadCrumbArray = this.getParentItem(item);        
        return breadCrumbArray;
    }
    
    removeItem(data, node) {
        let parents = this.getParentItem(node);
        data = this.walker(parents, data);
        return data;
    }
    
    addItem(data, parent, item) {
        let parents = this.getParentItem(parent);
        
    }

    walkerToAdd(keys, data, parent = 0) {
        let key = keys.shift();
        for(let j in data) {
            if(data[j].id == key.id) {
                let item = data[j];
                if(keys.length > 0 && item.children.length > 0) {
                    if(parent == 0) {
                    item = this.walker(keys, item.children, parent+1);    
                    } else {
                    item.children = walkerToAdd(keys, item.children, parent+1);    
                    }
                    
                } else {
                     
                    //delete data[j];
                    
                }
            }
        }
        return data;
    }
    
    walker(keys, data, parent = 0) {
        let key = keys.shift();
        for(let j in data) {
            if(data[j].id == key.id) {
                let item = data[j];
                if(keys.length > 0 && item.children.length > 0) {
                    if(parent == 0) {
                    item = this.walker(keys, item.children, parent+1);    
                    } else {
                    item.children = this.walker(keys, item.children, parent+1);    
                    }
                    
                } else {
                    data.splice(j, 1); 
                    //delete data[j];
                    
                }
            }
        }
        return data;
    }
}

export const TreeHelper = new TreeHelperClass();